import { Container, Graphics } from 'pixi.js';
import { chamferPanel } from './widgets';

/** Bar size as a share of the button size */
const BAR_W = 0.16;
const BAR_H = 0.5;
const BAR_GAP = 0.09;

/**
 * Pointer-only ‖ pause button (polish 1): the shop header's way into the
 * pause screen and its ⌂ MAIN MENU for mouse / touch — the same two bars as
 * the in-fight touch button. Pads and keys use Start / Esc instead, so it is
 * not part of the shop's focus list.
 */
export function buildPauseButton(size: number, onTap: () => void): Container {
  const c = new Container();
  const g = new Graphics();
  chamferPanel(g, size, size, { fill: 0x1a1626, stroke: 0x4a4256, strokeWidth: 2, notch: size * 0.22, plain: true });
  const bw = size * BAR_W;
  const bh = size * BAR_H;
  const top = (size - bh) / 2;
  for (const x of [size / 2 - BAR_GAP * size / 2 - bw, size / 2 + BAR_GAP * size / 2]) {
    g.roundRect(x, top, bw, bh, bw * 0.4).fill({ color: 0xffffff, alpha: 0.9 });
  }
  c.addChild(g);
  c.eventMode = 'static';
  c.cursor = 'pointer';
  c.on('pointertap', (e) => {
    e.stopPropagation();
    onTap();
  });
  return c;
}
